import React from 'react';
import { useUserProfileModal } from '../../context/UserProfileModalContext.tsx';
import { UserProfileDrawer } from '../chat/UserProfileDrawer.tsx';

export const UserProfileModal: React.FC<{
  onNavigateToChat?: (channelId?: string) => void;
}> = ({ onNavigateToChat }) => {
  const { isOpen, closeUserProfile, selectedUser } = useUserProfileModal();

  if (!isOpen || !selectedUser) return null;

  return (
    <UserProfileDrawer
      user={selectedUser}
      onClose={closeUserProfile}
      isDocked={false}
      onNavigateToChat={onNavigateToChat}
    />
  );
};
